/** A referential list of template field types: no tenant, no parameter. */
class FetchTemplateFieldTypes {
	constructor() {
		Object.freeze(this);
	}
}

export default FetchTemplateFieldTypes;
